export default __webpack_public_path__ + "static/Blitz39 01F4FBA6-818f7f183210b58f7aa271114da4248b.jpg";